import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../../configurations/services/config.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PatientsService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getPatientDetails(PatientID, ArchiveFlag) {
    return this.http.get<any>(
      environment.configUrl +
        "Patient/GetAllPatientDetails?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&ArchiveFlag=" +
        ArchiveFlag +
        "&CurrentDate=" +
        new Date()
    );
  }
  
  getDentistList() {
    return this.http.get<any>(
      environment.configUrl +
        "Patient/GetDentistList"        
    );
  }

  GetPatientList(PatientID, ArchiveFlag, LastPatientID, Index) {
    return this.http.get<any>(
      environment.configUrl +
        "Patient/GetPatientList?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&ArchiveFlag=" +
        ArchiveFlag +
        // "&LastPatientID=" +
        // LastPatientID +
        "&Index=" +
        Index +
        "&CurrentDate=" +
        new Date()
    );
  }

  
  GetAllNewPatientList(index) {
    return this.http.get<any>(
      environment.configUrl +
        "Patient/GetAllNewPatients?Index=" +
        index +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetReasons(staffId) {
    return this.http.get(environment.configUrl + "Appointment/GetReasons", {
      params: { StaffID: this.configService.enc(staffId.toString()) },
    });
  }

  ReadExcelFile(formdata, StaffID, FileName) {
    return this.http.post(
      environment.configUrl +
        "PatientFileUpload/ReadExcelFile?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&FileName=" +
        FileName +
        "&CurrentDate=" +
        new Date(),
      formdata
    );
  }

  SignUp(PatientData) {
    const data = {
      SignUpData: this.configService.enc(JSON.stringify(PatientData)),
    };
    return this.http.post(
      environment.configUrl + "Patient/PatientSignUp?CurrentDate=" + new Date(),
      data
    );
  }

  GetAddresses(postCode) {
    return this.http.get(
      "https://api.getAddress.io/find/" +
        postCode +
        "?api-key=" +
        environment.addresApiKey
    );
  }

  changePatientRefNumber(refNumber, patientID) {}

  GetPatientNotes(patientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/GetAllNotesByPatientID?PatientID=" +
        this.configService.enc(patientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  FindPatients(PatientData) {
    const data = {
      PatientData: this.configService.enc(JSON.stringify(PatientData)),
    };
    return this.http.post(
      environment.configUrl +
        "Patient/FindPatientByPatientData?CurrentDate=" +
        new Date(),
      data
    );
  }

  UpdatePatientRegNumberByPatientID(PatientID, PatientRegNumber) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientRegNumberByPatientID?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&PatientRegNumber=" +
        PatientRegNumber +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientStatusByPatientID(PatientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientStatusByPatientID?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetAllPatientInterest() {
    return this.http.get(
      environment.configUrl +
        "Patient/GetAllPatientInterest?CurrentDate=" +
        new Date()
    );
  }

  InsertOrUpdatePatientInterest(PatientInterest, PatientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/InsertOrUpdatePatientInterest?PatientInterest=" +
        JSON.stringify(PatientInterest) +
        "&PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateArchivedFlagByPatientID(ArchiveFlag, PatientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdateArchivedFlagByPatientID?ArchiveFlag=" +
        ArchiveFlag +
        "&PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientEmail(PatientID, Email) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientEmail?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&Email=" +
        this.configService.enc(Email.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientLandLineNumber(PatientID, LandLineNumber) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientLandLineNumber?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&LandLineNumber=" +
        this.configService.enc(LandLineNumber.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientPhoneNumber(PatientID, PhoneNumber) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientPhoneNumber?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&PhoneNumber=" +
        this.configService.enc(PhoneNumber.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientDOB(PatientID, DOB) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientDOB?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&DOB=" +
        this.configService.enc(DOB.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientAddress(AddressData) {
    const data = {
      AddressData: this.configService.enc(JSON.stringify(AddressData)),
    };
    return this.http.post(
      environment.configUrl +
        "Patient/UpdatePatientAddress?CurrentDate=" +
        new Date(),
      data
    );
  }

  GetLatestUploadedPatientFileDetails() {
    return this.http.get(
      environment.configUrl +
        "PatientFileUpload/GetLatestUploadedPatientFileDetails?CurrentDate=" +
        new Date()
    );
  }

  SearchImplementationForPatient(SearchPattern) {
    return this.http.get(
      environment.configUrl +
        "Patient/SearchImplementationForPatient?SearchPattern=" +
        SearchPattern +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateTitleForPatient(PatientID, Title) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdateTitleForPatient?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&Title=" +
        this.configService.enc(Title.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateAssignedDentist(PatientID, DentistName) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdateAssignedDentist?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&DentistName=" +
        this.configService.enc(DentistName.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetPatientListAdvanceSearchImplementation(ArchiveFlag, SearchPattern) {
    var pattern = JSON.stringify(SearchPattern)
    return this.http.get(
      environment.configUrl +
        "Patient/GetPatientListAdvanceSearchImplementation?ArchiveFlag=" +
        ArchiveFlag +
        "&SearchPattern=" +pattern
        +
        "&CurrentDate=" +
        new Date()
    );
  }


  GetPatientListSearchImplementation(ArchiveFlag, SearchPattern) {
    return this.http.get(
      environment.configUrl +
        "Patient/GetPatientListSearchImplementation?ArchiveFlag=" +
        ArchiveFlag +
        "&SearchPattern=" +
        SearchPattern +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdatePatientIsContacted(PatientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/UpdatePatientIsContacted?PatientID=" +
        this.configService.enc(PatientID.toString()) +
        "&IsContacted=1&CurrentDate=" +
        new Date()
    );
  }
}

// getReasonsForDoctor(staffId) {
//   return this.http.get(
//     `${environment.configUrl}Appointment/GetReasons`,
//     { params: { StaffID: this.configService.enc(staffId.toString()) } }
//   );
// }

// InsertPatientsAndSlotFromAdmin(slotID, PatientID, reasonID) {
//   return this.http.get(environment.configUrl + 'Appointment/InsertPatientsAndSlotFromAdmin?AppointmentScheduleSlotLevelID=' + slotID + '&PatientID=' + this.configService.enc(PatientID.toString()) + '&ReasonID=' + reasonID + '&CurrentDate=' + new Date());
// }

// GetPatientsListByPatientID(PatientID) {
//   return this.http.get(
//     environment.configUrl +
//       "Patient/GetAllPatientDetails?PatientID=" +
//       this.configService.enc(PatientID.toString()) +
//       "&CurrentDate=" +
//       new Date()
//   );
// }
